export enum Breakpoints {
  // Bulma's default tablet/desktop threshold (1024px desktop, so max-width 1023px targets mobile+tablet)
  XSmall = "767px",
  Small = "1101px",
  Medium = "1215px",
  Large = "1407px",
}
